<script setup>
import { computed } from 'vue';

const props = defineProps({
  width: {
    type: Number,
    required: true,
  },
  height: {
    type: Number,
    required: true,
  },
  selected: {
    type: Boolean,
    default: false,
  },
  unit: {
    type: String,
    default: '',
  },
  class: {
    type: String,
    default: '',
  },
});

// 计算缩略图的宽高，保持最大宽24px，高20px，等比缩放
const previewSize = computed(() => {
  const maxW = 24;
  const maxH = 20;
  const w = props.width;
  const h = props.height;
  const scale = Math.min(maxW / w, maxH / h, 1);
  return {
    width: `${Math.round(w * scale)}px`,
    height: `${Math.round(h * scale)}px`,
  };
});
</script>

<template>
  <div
    class="w-10 h-8 shrink-0 bg-white rounded-md flex items-center justify-center border border-black/10 shadow-sm"
    :class="[selected ? 'border-emerald-300 bg-emerald-50' : '', props.class]"
  >
    <div
      :class="selected ? 'bg-emerald-400' : 'bg-black/40'"
      :style="{
        ...previewSize,
        borderRadius: '3px',
        transition: 'background 0.2s',
      }"
    ></div>
  </div>
</template>
